<template>
    <div class="legal-component text-none pa-4 pa-md-8 mb-16">
        <div class="main-header mb-10 pt-10" v-html="$t('legal_information.main_header')"></div>
        <p class="text-left text mb-6" v-html="$t('legal_information.main_text')"></p>

        <div class="header bold mb-4">§1. {{ $t('legal_information.general_provision.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.general_provision.p_1')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.general_provision.p_2')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.general_provision.p_3')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.general_provision.p_4')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.general_provision.p_5')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.general_provision.p_6')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.general_provision.p_7')"></li>
        </ol>

        <div class="header bold mb-4">§2. {{ $t('legal_information.definitions.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first">{{ $t('legal_information.definitions.p_1') }}
                <ol class="mt-2">
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_1')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_2')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_3')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_4')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_5')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_6')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_7')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_8')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_9')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_10')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_11')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_12')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_13')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_14')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_15')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_16')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_17')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_18')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_19')"></li>
                    <li class="second mb-2" v-html="$t('legal_information.definitions.sub_1_20')"></li>
                </ol>
            </li>
        </ol>

        <div class="header bold mb-4">§3. {{ $t('legal_information.subject_of_contract.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.subject_of_contract.p_1')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.subject_of_contract.p_2')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.subject_of_contract.p_3')"></li>
        </ol>

        <div class="header bold mb-4">§4. {{ $t('legal_information.statements_of_parties.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first">{{ $t('legal_information.statements_of_parties.p_1') }}
                <ol class="mt-2">
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_1_1')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_1_2')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_1_3')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_1_4')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_1_5')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_1_6')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_1_7')"></li>
                </ol>
            </li>
            <li class="mb-4 first">{{ $t('legal_information.statements_of_parties.p_2') }}
                <ol class="mt-2">
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_1')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_2')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_3')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_4')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_5')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_6')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_7')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_8')"></li>
                    <li class="mb-2 second" v-html="$t('legal_information.statements_of_parties.sub_2_9')"></li>
                </ol>
            </li>

            <li class="mb-4 first">{{ $t('legal_information.statements_of_parties.p_3') }}</li>
        </ol>

        <div class="header bold mb-4">§5. {{ $t('legal_information.place_and_method_of_storage.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.place_and_method_of_storage.p_1')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.place_and_method_of_storage.p_2')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.place_and_method_of_storage.p_3')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.place_and_method_of_storage.p_4')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.place_and_method_of_storage.p_5')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.place_and_method_of_storage.p_6')"></li>
        </ol>

        <div class="header bold mb-4">§6. {{ $t('legal_information.deposit.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.deposit.p_1')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.deposit.p_2')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.deposit.p_3')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.deposit.p_4')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.deposit.p_5')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.deposit.p_6')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.deposit.p_7')"></li>
        </ol>

        <div class="header bold mb-4">§7. {{ $t('legal_information.processing.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.processing.p_1')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.processing.p_2')"></li>
        </ol>

        <div class="header bold mb-4">§8. {{ $t('legal_information.distribution.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.distribution.p_1')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.distribution.p_2')"></li>
        </ol>

        <div class="header bold mb-4">§9. {{ $t('legal_information.reservation.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_1')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_2')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_3')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_4')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_5')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_6')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_7')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_8')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_9')"></li>
        </ol>
        <div class="table-wrapper mb-6 ml-6">
            <table cellspacing="0" cellpadding="0" border="1">
                <tr>
                    <td colspan="4" class="first"><span class="bold">{{ $t('legal_information.reservation.table.title') }}</span></td>
                </tr>
                <tr>
                    <td><span class="bold">{{ $t('legal_information.reservation.table.reason_for_cancellation_th') }}</span></td>
                    <td><span class="bold">{{ $t('legal_information.reservation.table.term_of_cancellation_th') }}</span></td>
                    <td><span class="bold">{{ $t('legal_information.reservation.table.refund_of_reservation_amount_th') }}</span></td>
                    <td><span class="bold">{{ $t('legal_information.reservation.table.comments_th') }}</span></td>
                </tr>
                <tr>
                    <td rowspan="3">{{ $t('legal_information.reservation.table.reason_1') }}</td>
                    <td>{{ $t('legal_information.reservation.table.up_to_3_months_from_reservation_text') }}</td>
                    <td>100%</td>
                    <td>{{ $t('legal_information.reservation.table.at_no_cost_to_patient_text') }}</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.from_3_to_12_months_from_reservation_text') }}</td>
                    <td>90%</td>
                    <td>{{ $t('legal_information.reservation.table.administration_fee_text') }}</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.after_12_months_from_reservation_text') }}</td>
                    <td>{{ $t('legal_information.reservation.table.in_accordance_with_conditions_for_return_text') }}</td>
                    <td>{{ $t('legal_information.reservation.table.no_possibility_of_change_text') }}</td>
                </tr>
                <tr>
                    <td rowspan="3">{{ $t('legal_information.reservation.table.reason_2') }}</td>
                    <td>{{ $t('legal_information.reservation.table.up_to_3_months_from_reservation_text') }}</td>
                    <td>95%</td>
                    <td>{{ $t('legal_information.reservation.table.administration_fee_text') }}</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.from_3_to_12_months_from_reservation_text') }}</td>
                    <td>90%</td>
                    <td>{{ $t('legal_information.reservation.table.administration_fee_text') }}</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.after_12_months_from_reservation_text') }}</td>
                    <td>{{ $t('legal_information.reservation.table.in_accordance_with_conditions_for_return_text') }}</td>
                    <td>{{ $t('legal_information.reservation.table.no_possibility_of_change_text') }}</td>
                </tr>
                <tr>
                    <td rowspan="5">{{ $t('legal_information.reservation.table.reason_3') }}</td>
                    <td>{{ $t('legal_information.reservation.table.up_to_3_months_from_reservation_text') }}</td>
                    <td>90%</td>
                    <td rowspan="5">{{ $t('legal_information.reservation.table.deposit_held_at_text') }}</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.from_3_to_12_months_from_reservation_text') }}</td>
                    <td>70%</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.from_12_to_24_months_from_reservation_text') }}</td>
                    <td>50%</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.from_24_to_60_months_from_reservation_text') }}</td>
                    <td>30%</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.over_60_months_from_reservation_text') }}</td>
                    <td>{{ $t('legal_information.reservation.table.no_return_text') }}</td>
                </tr>
                <tr>
                    <td>{{ $t('legal_information.reservation.table.reason_5') }}</td>
                    <td>{{ $t('legal_information.reservation.table.regardless_of_cancellation_term_text') }}</td>
                    <td>{{ $t('legal_information.reservation.table.no_return_text') }}</td>
                    <td>{{ $t('legal_information.reservation.table.deposit_held_at_text') }}</td>
                </tr>
            </table>
        </div>
        <ol start="10" class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_10')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_11')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_12')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_13')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.reservation.p_14')"></li>
        </ol>

        <div class="header bold mb-4">§10. {{ $t('legal_information.storage_and_reservation_fee.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first">{{ $t('legal_information.storage_and_reservation_fee.p_1') }}
                <ol type="a" class="mt-2">
                    <li class="mb-2 second">{{ $t('legal_information.storage_and_reservation_fee.sub_1_1') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.storage_and_reservation_fee.sub_1_2') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.storage_and_reservation_fee.sub_1_3') }}</li>
                </ol>
            </li>
            <li class="mb-4 first" v-html="$t('legal_information.storage_and_reservation_fee.p_2')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.storage_and_reservation_fee.p_3')"></li>
            <li class="mb-4 first">{{ $t('legal_information.storage_and_reservation_fee.p_4') }}
                <ol type="a" class="mt-2">
                    <li class="mb-2 second">{{ $t('legal_information.storage_and_reservation_fee.sub_4_1') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.storage_and_reservation_fee.sub_4_2') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.storage_and_reservation_fee.sub_4_3') }}</li>
                </ol>
            </li>
            <li class="mb-4 first" v-html="$t('legal_information.storage_and_reservation_fee.p_5')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.storage_and_reservation_fee.p_6')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.storage_and_reservation_fee.p_7')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.storage_and_reservation_fee.p_8')"></li>
        </ol>

        <div class="header bold mb-4">§11. {{ $t('legal_information.duration_of_agreement.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first" v-html="$t('legal_information.duration_of_agreement.p_1')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.duration_of_agreement.p_2')"></li>
            <li class="mb-4 first" v-html="$t('legal_information.duration_of_agreement.p_3')"></li>
        </ol>

        <div class="header bold mb-4">§12. {{ $t('legal_information.dissolution_of_agreement.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-4 first">{{ $t('legal_information.dissolution_of_agreement.p_1') }}
                <ol class="mt-2">
                    <li class="mb-2 second">{{ $t('legal_information.dissolution_of_agreement.sub_1_1') }}</li>
                </ol>
                <u>{{ $t('legal_information.gametes_label') }}:</u>
                <ol start="2" class="mt-2">
                    <li class="mb-2 second">{{ $t('legal_information.dissolution_of_agreement.sub_1_2') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.dissolution_of_agreement.sub_1_3') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.dissolution_of_agreement.sub_1_4') }}</li>
                </ol>
                <u>{{ $t('legal_information.embryos_label') }}:</u>
                <ol start="5" class="mt-2">
                    <li class="mb-2 second">{{ $t('legal_information.dissolution_of_agreement.sub_1_5') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.dissolution_of_agreement.sub_1_6') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.dissolution_of_agreement.sub_1_7') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.dissolution_of_agreement.sub_1_8') }}</li>
                </ol>
            </li>
        </ol>

        <div class="header bold mb-4">§13. {{ $t('legal_information.termination_of_agreement.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-2 first">{{ $t('legal_information.termination_of_agreement.p_1') }}
                <br />
                <br />
                <u>{{ $t('legal_information.gametes_label') }}:</u>
            </li>
            <li class="mb-4 first">{{ $t('legal_information.termination_of_agreement.p_2') }}
                <ol class="mt-2">
                    <li class="mb-2 second">{{ $t('legal_information.termination_of_agreement.sub_2_1') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.termination_of_agreement.sub_2_2') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.termination_of_agreement.sub_2_3') }}</li>
                </ol>
            </li>
            <li class="mb-4 first">{{ $t('legal_information.termination_of_agreement.p_3') }}</li>
            <li class="mb-2 first">{{ $t('legal_information.termination_of_agreement.p_4') }}
                <br />
                <br />
                <u>{{ $t('legal_information.embryos_label') }}:</u>
            </li>
            <li class="mb-4 mt-2 first">{{ $t('legal_information.termination_of_agreement.p_5') }}
                <ol class="mt-2">
                    <li class="mb-2 second">{{ $t('legal_information.termination_of_agreement.sub_5_1') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.termination_of_agreement.sub_5_2') }}</li>
                </ol>
            </li>
            <li class="mb-4 first">{{ $t('legal_information.termination_of_agreement.p_6') }}</li>
            <li class="mb-4 first">{{ $t('legal_information.termination_of_agreement.p_7') }}</li>
        </ol>

        <div class="header bold mb-4">§14. {{ $t('legal_information.transfer_of_deposit_to_another_bank.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_to_another_bank.p_1')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_to_another_bank.p_2')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_to_another_bank.p_3')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_to_another_bank.p_4')"></li>
        </ol>

        <div class="header bold mb-4">§15. {{ $t('legal_information.transfer_of_deposit_for_donation.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_for_donation.p_1')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_for_donation.p_2')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_for_donation.p_3')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_for_donation.p_4')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_for_donation.p_5')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_for_donation.p_6')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.transfer_of_deposit_for_donation.p_7')"></li>
        </ol>

        <div class="header bold mb-4">§16. {{ $t('legal_information.destruction_of_deposit.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-2 first" v-html="$t('legal_information.destruction_of_deposit.p_1')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.destruction_of_deposit.p_2')"></li>
        </ol>

        <div class="header bold mb-4">§17. {{ $t('legal_information.issuing_deposit_to_clinic.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-2 first" v-html="$t('legal_information.issuing_deposit_to_clinic.p_1')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.issuing_deposit_to_clinic.p_2')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.issuing_deposit_to_clinic.p_3')"></li>
        </ol>

        <div class="header bold mb-4">§18. {{ $t('legal_information.accepting_deposit_from_another_bank.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-2 first" v-html="$t('legal_information.accepting_deposit_from_another_bank.p_1')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.accepting_deposit_from_another_bank.p_2')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.accepting_deposit_from_another_bank.p_3')"></li>
        </ol>

        <div class="header bold mb-4">§19. {{ $t('legal_information.risks_and_liability.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-2 first" v-html="$t('legal_information.risks_and_liability.p_1')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.risks_and_liability.p_2')"></li>
            <li class="mb-2 first">{{ $t('legal_information.risks_and_liability.p_3') }}
                <ol class="mt-2">
                    <li class="mb-2 second">{{ $t('legal_information.risks_and_liability.sub_3_1') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.risks_and_liability.sub_3_2') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.risks_and_liability.sub_3_3') }}</li>
                    <li class="mb-2 second">{{ $t('legal_information.risks_and_liability.sub_3_4') }}</li>
                </ol>
            </li>
            <li class="mb-2 first" v-html="$t('legal_information.risks_and_liability.p_4')"></li>
        </ol>

        <div class="header bold mb-4">§20. {{ $t('legal_information.final_provisions.header') }}</div>
        <ol class="text-left text ml-4 mb-6">
            <li class="mb-2 first" v-html="$t('legal_information.final_provisions.p_1')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.final_provisions.p_2')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.final_provisions.p_3')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.final_provisions.p_4')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.final_provisions.p_5')"></li>
            <li class="mb-2 first" v-html="$t('legal_information.final_provisions.p_6')"></li>
        </ol>
    </div>
</template>

<script>

export default {
    name: "legal-component",
    mounted() {
        this.$store.dispatch('breadcrumbModule/setRoute', [{
            name: 'breadcrumb.want_to_be_a_parent',
            url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
            absolute: true
        },{
            name: 'breadcrumb.dashboard',
            url: '/dashboard?selected=personal-details'
        },
        {
          name: 'breadcrumb.dashboard_labels.legal_information',
          url: ''
        }
      ])
    }
}
</script>

<style lang="scss" scoped>
.legal-component {
    background: white;
}

.main-header {
    @include nsb-gentium-bold;
    font-size: 28px;
    line-height: 32px;
}

.header {
    @include nsb-gentium-bold;
    font-size: 18px;
    line-height: 24px;
}

.text {
    @include nsb-font-container;
    font-size: 14px;
    line-height: 24px;
}

.emphasis {
    margin-top: 4px;
    margin-bottom: 4px;
}

.link {
    text-decoration: underline !important;
    font-weight: bold;
    cursor: pointer;
}

li.first {
    position: relative;
    padding-left: 5px;
}

li.second {
    position: relative;
    margin-left: 20px;
    padding-left: 5px;
}

li.bracket:before {
    content: ") ";
    counter-increment: list;
}

li:before {
    position: absolute;
    left: -5px;
}

.table-wrapper {
    overflow-x: auto;
    border: 1px solid $ds-primary;

    td {
        width: 25%;
        padding: 8px;
        border-color: $ds-primary;
        color: $ds-primary;

        &.first {
            border-bottom: 2px solid $ds-primary;
        }
    }

    table {
        width: 100%;
        min-width: 600px;
        border-collapse: collapse;
    }
}

@media (min-width: 960px) {
    .legal-component {
        background: white;
    }

    li.first {
        position: relative;
        padding-left: 10px;
    }

    li.second {
        position: relative;
        margin-left: 40px;
        padding-left: 10px;
    }

    li.bracket:before {
        content: ") ";
        counter-increment: list;
    }

    li:before {
        position: absolute;
        left: -5px;
    }
}
</style>